import React from "react";
import SEO from "../components/SEO";
const Shipping = () => (
  <>
    <SEO title="Shipping Policy" />
    <section className="max-w-3xl mx-auto px-6 py-16 prose-invert text-white/80 leading-relaxed">
      <p className="font-mono-cap text-[10px] text-white/40">Policy</p>
      <h1 className="font-serif text-5xl mt-2 text-white">Shipping Policy.</h1>
      <div className="mt-8 space-y-5 text-sm">
        <p>We ship across India including Delhi NCR and all metros, tier-2, and tier-3 cities.</p>
        <p><b className="text-white">Dispatch time:</b> Orders are processed and dispatched within 24-48 hours of confirmation.</p>
        <p><b className="text-white">Delivery time:</b> 5-7 business days from dispatch. Remote pincodes may take slightly longer.</p>
        <p><b className="text-white">Shipping charges:</b> Flat ₹99 on orders below ₹1,999. Free shipping on orders ₹1,999 and above.</p>
        <p><b className="text-white">Tracking:</b> Tracking details are shared via WhatsApp (+91 8383862206) and email once your order is dispatched.</p>
        <p><b className="text-white">Failed deliveries:</b> If a COD order is refused at delivery, future COD on that number/address may be disabled.</p>
      </div>
    </section>
  </>
);
export default Shipping;
